import React from 'react';
import CCCertificate from "./CCCertificate"

const CourseCompletion = () => {
  return (
    <div>
        <CCCertificate
                studentName="John Doe"
                courseTitle="Secondary School Leaving Certificate"
                startDate="January 1, 2024"
                completionDate="March 31, 2024"
                issueDate="April 1, 2024"
                instructorName="Jane Smith"
                directorName="Dr. Emily White"
                institutionName="Name of Institution"
            />
    </div>
  )
}

export default CourseCompletion
